import { VueHeadMixin, createHead as unheadCreateClientHead } from '@unhead/vue/client'

import { tagsResolveHook } from './shared'

export { VueHeadMixin }
export const createHead = () => {
    return unheadCreateClientHead({
        hooks: {
            'tags:resolve': tagsResolveHook,
        },
    })
}
